import { v2Colors, breakpoints } from '@web-for-marketing/react-ui';
import { typographyStyles } from '@web-for-marketing/react-ui';

export const blogCardStyle = {
    image: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        transition: 'transform 0.3s ease-in-out',
    },
    cardContent: {
        padding: '0  1.6rem 1.6rem 1.6rem',
    },
    category: {
        display: 'inline-block',
        borderRadius: '2rem',
        padding: '4px 8px',
        border: '1px solid',
        borderColor: v2Colors.border.primary,
        backgroundColor: v2Colors.background.white,
        position: 'relative',
        outline: 'none',
        '&:focus-within': {
            outline: `1px solid ${v2Colors.border.activePrimary}`,
            outlineOffset: '3px',
            borderRadius: '2rem',
        },
        '& a': {
            textDecoration: 'none',
            outline: 'none',
        },
        '&:hover': {
            backgroundColor: v2Colors.action.active,
        },
    },
    description: {
        marginBottom: '0.8rem',
    },
    timeBlock: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        width: '100%',
    },
    readMinutes: {
        display: 'flex',
        alignitems: 'center',
    },
    divider: {
        ...typographyStyles.body2,
        margin: '0 8px',
        [`@media (max-width: ${breakpoints.xs})`]: {
            display: 'none',
        },
    },
} as const;
